import PaperButton from "components/buttons/PaperButton";
import CustomTable from "components/CustomTable";
import { currency } from "lib/formatter";
import React from "react";

export default function ShippingRatesTable({ data = {}, onView = () => {} }) {
  return (
    <div>
      <CustomTable
        data={data}
        columns={[
          // {label: " ", cell: (row) =>  },
          {
            label: "NAME",
            selector: "name",
            cellCSS: "p-0",
          },
          {
            label: "RATE",
            selector: "rate",
            cell: (row, index) => currency.format(row?.rate),
          },
          {
            label: "",
            selector: "actions",
            cell: (row, rowIndex) => (
              <PaperButton
                onClick={() => onView(row, rowIndex)}
                variant="text"
                color="primary"
              >
                Edit Rate
              </PaperButton>
            ),
          },
        ]}
      />
    </div>
  );
}
